<script setup>

import { useStore } from "vuex";
import validSession from '../assets/js/valid-session';
import { onBeforeMount } from 'vue';
import loadGif from "@/assets/img/loading.gif";
import axios from "axios";
import { toast } from 'vue3-toastify';
import { computed } from "vue";

const store = useStore();

const darkMode = computed(() => store.state.darkMode);

onBeforeMount(() => {

    validSession.isLogged();

    store.state.message = {
        subject: '',
        description: ''
    };

    store.state.validation = {
        subjectHasError: false,
        subjectMessageError: '',
        descriptionHasError: false,
        descriptionMessageError: '',
    }

    store.state.sendingMessage = false;

});

const submitMessage = async () => {

    let data = new FormData();

    store.state.sendingMessage = true;

    store.state.subjectHasError = false;
    store.state.descriptionHasError = false;

    data.append('subject', store.state.message.subject);
    data.append('description', store.state.message.description);

    let url = '/support/send';
    let toast_message = 'Mensagem envianda! Você receberá nosso retorno no e-mail cadastrado.';

    await axios.post(url, data)
    .then(res => {

        if(res.data.error){

            let messages = res.data.messages;

            Object.entries(messages).forEach((value) => {

                if(value[0] == 'subject'){
                    store.state.validation.subjectHasError = true;
                    store.state.validation.subjectMessageError = value[1];
                }
                else if(value[0] == 'description'){
                    store.state.validation.descriptionHasError = true;
                    store.state.validation.descriptionMessageError = value[1];
                }


            });

            if(res.data.error == 'Não foi possível realizar enviar a mensagem no momento tente mais tarde!'){

                toast('Não foi possível realizar enviar a mensagem no momento tente mais tarde!', {
                    autoClose: 3000,
                    theme: "auto",
                    type: "error",
                    transition: "slide"
                });

            }

            store.state.sendingMessage = false;

        }
        else{

            store.state.validation = {
                subjectHasError: false,
                subjectMessageError: '',
                descriptionHasError: false,
                descriptionMessageError: '',
            }   

            store.state.message = {
                subject: '',
                description: ''
            };

            toast(toast_message, {
                autoClose: 3000,
                theme: "auto",
                type: "success",
                transition: "slide"
            });

            store.state.sendingMessage = false;


        }

    })
    .catch(err => {
        toast('Não foi possível realizar a operação, tente mais tarde (Erro '+err.response.status+')', {
            autoClose: 1000,
            theme: "auto",
            type: "error",
            transition: "slide"
        });

        store.state.sendingMessage = false;
    })

}

</script>

<template>
     <div class="py-4 container-fluid overflow-auto max-height-vh-90 support-page">
        <div class="row">
            <div class="col-12">
                <div class="card support-shell border-0">
                    <div class="card-header support-header border-0">
                        <div class="support-header-top">
                            <div class="support-title-wrap">
                                <span class="support-eyebrow">Suporte</span>
                                <h3 class="support-title">Central de suporte</h3>
                                <p class="support-subtitle mb-0">Descreva seu problema e envie sua solicitação para nossa equipe.</p>
                            </div>
                        </div>
                    </div>

                    <div class="card-body support-body">
                        <div class="support-form-card">
                            <div class="support-form-intro">
                                <div class="support-form-icon">
                                    <i class="fal fa-life-ring"></i>
                                </div>
                                <div>
                                    <h5>Precisando de ajuda?</h5>
                                    <p class="mb-0">Explique o ocorrido com o máximo de detalhes para agilizar o atendimento.</p>
                                </div>
                            </div>

                            <div class="row g-3">
                                <div class="col-12">
                                    <label for="messageSubject" class="support-label">Assunto</label>
                                    <input 
                                        type="text" 
                                        class="form-control form-control-lg support-input" 
                                        id="messageSubject"
                                        name="messageSubject"
                                        placeholder="Assunto"
                                        v-model="store.state.message.subject"
                                        v-bind:class="{
                                                'is-invalid': store.state.validation.subjectHasError,
                                                'darkmode': darkMode,
                                            }"
                                    >
                                    <div id="messageSubjectFeedback" class="invalid-feedback">
                                        {{ store.state.validation.subjectMessageError }}
                                    </div>
                                </div>

                                <div class="col-12">
                                    <label for="messageDescription" class="support-label">Descreva o problema</label>
                                    <textarea 
                                        id="messageDescription" 
                                        rows="6" 
                                        class="form-control support-textarea" 
                                        v-model="store.state.message.description"
                                        v-bind:class="{
                                            'is-invalid': store.state.validation.descriptionHasError,
                                            'darkmode': darkMode,
                                        }"
                                        placeholder="Conte o que aconteceu, em qual tela ocorreu e o que você esperava que acontecesse."
                                    ></textarea>
                                    <div id="messageDescriptionFeedback" class="invalid-feedback">
                                        {{ store.state.validation.descriptionMessageError }}
                                    </div>
                                </div>

                                <div class="col-12 text-center mt-2">
                                    <button
                                        v-if="!store.state.sendingMessage"
                                        @click="submitMessage()"
                                        class="btn support-submit-btn"
                                    >
                                        Solicitar suporte
                                    </button>
                                    <img v-if="store.state.sendingMessage" :src="loadGif" alt="" width="50">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.support-shell{
    overflow: hidden;
    border-radius: 24px !important;
    background: #f6f3eb;
    box-shadow: 0 12px 40px rgba(24, 39, 75, 0.08);
}

.support-header{
    padding: 1.8rem 1.5rem 1.5rem;
    background: linear-gradient(135deg, #1f4876 0%, #224a78 55%, #1f436d 100%);
}

.support-header-top{
    display:flex;
    align-items:flex-start;
    justify-content:space-between;
    gap:16px;
}

.support-title-wrap{
    min-width:0;
}

.support-eyebrow{
    display:inline-block;
    margin-bottom:10px;
    font-size:0.92rem;
    color: rgba(255,255,255,0.78);
}

.support-title{
    margin:0;
    font-size:2rem;
    line-height:1.1;
    font-weight:800;
    color:#ffffff;
}

.support-subtitle{
    margin-top:10px;
    color: rgba(255,255,255,0.66);
    font-size:1rem;
}

.support-body{
    padding:1.4rem !important;
    background:#f7f4ee;
}

.support-form-card{
    background: rgba(255,255,255,0.88);
    border: 1px solid #dbe5f0;
    border-radius: 22px;
    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.04);
    padding: 1rem;
}

.support-form-intro{
    display:flex;
    align-items:center;
    gap:14px;
    padding: 0.95rem 1rem;
    border:1px solid #dbe5f0;
    border-radius:18px;
    background:#f8fafc;
    margin-bottom:1rem;
}

.support-form-icon{
    width:52px;
    height:52px;
    min-width:52px;
    border-radius:16px;
    display:flex;
    align-items:center;
    justify-content:center;
    background: rgba(216, 146, 57, 0.12);
    color:#d89239;
    font-size:1.3rem;
}

.support-form-intro h5{
    margin:0 0 .2rem 0;
    color:#213E60;
    font-size:1rem;
    font-weight:800;
}

.support-form-intro p{
    color:#6b7c93;
    font-size:.9rem;
}

.support-label{
    display:block;
    margin-bottom:.45rem;
    color:#344766;
    font-weight:700;
    font-size:.95rem;
}

.support-input,
.support-textarea{
    border-radius:15px !important;
    border:1px solid #d7e0ea !important;
    background:#ffffff !important;
    box-shadow:none !important;
    color:#344766;
}

.support-input{
    min-height:54px !important;
}

.support-textarea{
    min-height:180px !important;
    resize:vertical;
    padding:1rem !important;
}

.support-input:focus,
.support-textarea:focus{
    border-color:#8aa8ca !important;
    box-shadow:0 0 0 4px rgba(138,168,202,0.14) !important;
}

.support-submit-btn{
    min-height:50px;
    padding:0 1.5rem;
    border:none !important;
    border-radius:15px !important;
    background: linear-gradient(135deg, #2fd18b 0%, #27c67f 100%) !important;
    color:#ffffff !important;
    font-weight:800 !important;
    box-shadow:0 18px 34px rgba(39,198,127,0.24);
}

.support-submit-btn:hover,
.support-submit-btn:focus{
    transform:translateY(-1px);
    color:#ffffff !important;
    background: linear-gradient(135deg, #36d993 0%, #29cb84 100%) !important;
}

@media (max-width: 991.98px){
    .support-header{
        padding:1.3rem 1rem 1.2rem;
    }

    .support-title{
        font-size:1.65rem;
    }

    .support-body{
        padding:1rem !important;
    }
}

@media (max-width: 575.98px){
    .support-shell{
        border-radius:20px !important;
    }

    .support-title{
        font-size:1.35rem;
    }

    .support-subtitle{
        font-size:.9rem;
    }

    .support-form-intro{
        align-items:flex-start;
    }

    .support-submit-btn{
        width:100%;
    }
}
</style>
